module.exports = __webpack_public_path__ + "static/fonts/DejaVuSerif-Bold.25670b4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/fonts/DejaVu/DejaVuSerif-Bold.ttf?v=1.1
// module id = 1638
// module chunks = 28